import * as Immutable from 'seamless-immutable';
import {
  PERMISSIONS_VIOLATION_FOUND,
} from '../actions';

const initialState = Immutable.from({
  hasGrowled: false,
  hasViolation: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case PERMISSIONS_VIOLATION_FOUND:
      return state.merge({ hasGrowled: action.meta.hasGrowled, hasViolation: true });
    default:
      return state;
  }
};
